"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../../ui/Button"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover > path {\n        fill: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var SaveIcon = function SaveIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.3337 12.3332C14.6811 12.3332 16.7394 12.767 18.5085 13.6345C19.0135 13.8822 19.3337 14.3957 19.3337 14.9582C19.3337 15.5287 19.1648 16.0865 18.8483 16.5612L18.167 17.5832C17.4381 18.6765 16.211 19.3332 14.8971 19.3332H9.77025C8.45626 19.3332 7.22919 18.6765 6.50032 17.5832L6.10662 16.9947C6.93812 16.9499 7.75672 16.6099 8.39189 15.9747L9.90021 14.4663L10.1052 14.2463C10.5841 13.6789 10.912 13.04 11.0922 12.3771C11.4942 12.3474 11.9092 12.3332 12.3337 12.3332ZM6.63206 7.91117L6.74193 8.00823L8.25032 9.51659C9.11359 10.3798 9.15901 11.7512 8.38662 12.668L8.25032 12.8164L6.74193 14.3248C6.28632 14.7804 5.54766 14.7804 5.09205 14.3248C4.67149 13.9042 4.63913 13.2425 4.99499 12.7848L5.09205 12.6749L5.43164 12.3332H1.83366C1.18933 12.3332 0.666992 11.8108 0.666992 11.1665C0.666992 10.5222 1.18933 9.99984 1.83366 9.99984H5.43285L5.09205 9.65811C4.63644 9.2025 4.63644 8.46384 5.09205 8.00823C5.51262 7.58766 6.17439 7.55531 6.63206 7.91117ZM12.2783 0.666504C15.2496 0.666504 17.0003 3.01701 17.0003 5.9165C17.0003 7.7399 16.1566 9.30073 14.9037 10.2419C14.1643 10.7973 13.381 11.1665 12.2783 11.1665C11.9131 11.1665 11.5721 11.1081 11.253 11.0098C11.2234 9.8593 10.7662 8.73267 9.90021 7.86667L8.39189 6.35831L8.28643 6.25919L8.17648 6.16213L8.06433 6.06914C7.93752 5.97054 7.80572 5.88193 7.66998 5.80325L7.66699 5.9165C7.66699 3.01701 9.30694 0.666504 12.2783 0.666504Z",
    fill: "#3d3d3d"
  }));
};
var SaveOrderButton = function SaveOrderButton(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isSaved = _ref.isSaved,
    theme = _ref.theme,
    width = _ref.width,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeIcon: isSaved,
    className: className,
    icon: /*#__PURE__*/_react.default.createElement(SaveIcon, null),
    width: width,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.MEDIUM,
    theme: theme,
    title: t('SAVE_TOUR_TO_CLAIM_BUTTON'),
    onClick: onClick
  }, children);
};
SaveOrderButton.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  isSaved: _propTypes.default.bool,
  theme: _propTypes.default.oneOf(Object.values(_Button.THEMES)),
  width: _propTypes.default.oneOf(Object.values(_Button.WIDTHS)),
  onClick: _propTypes.default.func
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(SaveOrderButton);